import React, { useEffect } from 'react';
import POIIcon from './poi-icon';

export interface LogEventType {
  eventName: string;
  eventParams: Record<string, any>
}

interface PoiArchorPropType {
  dataType: string;
  dataName: string;
  dataRegion: string;
  dataId: string;
  onPoiArchorClick: (topicHref: string, dataId: string) => void;
  onLogEvent: (data: LogEventType) => void;
};

export const PoiArchorItem: React.FC<PoiArchorPropType> = props => {

  const { dataType, dataName, dataRegion, dataId, onPoiArchorClick, onLogEvent } = props;
  const poiPath = `/poi/${dataId}`;
  const poiHref = `${poiPath}?region=${dataRegion}`;

  const handleItemClick = (e: any) => {
    e.preventDefault();
    onPoiArchorClick(poiHref, dataId);
  };

  return (
    <a
      onClick={handleItemClick}
      key={`poi-${dataId}`}
      href={poiHref}
      className="l8editor-poi"
    >
      <POIIcon />
      <span className="l8-poi-anchor-name">{dataName} </span>
    </a>
  );
};
